import { Suspense } from 'react';

import type { ProductType } from '@xing-com/crate-common-graphql-types';
import { useLocation } from '@xing-com/crate-core-router';
import { useProductParameter } from '@xing-com/crate-upsell-utils';
import { useHost } from '@xing-com/crate-xinglet';

import { useCampaignLoggedOut } from '../hooks/use-campaign-logged-out';

import { CampaignPage } from './campaign-page';

export const CampaignPageLoggedOutInner: React.FC<{
  mid: string;
  product: ProductType;
}> = ({ mid, product }) => {
  const { campaign, status } = useCampaignLoggedOut({ mid, product });

  return (
    <CampaignPage
      product={product}
      campaign={campaign}
      loading={false}
      status={status}
    />
  );
};

export const CampaignPageLoggedOut: React.FC = () => {
  const host = useHost();
  const { product } = useProductParameter();

  const searchParams = new URLSearchParams(useLocation().search);
  const mid = searchParams.get('mid'); // marketing identifier

  // mid param must belong to an valid campaign, e.g. "om_cmp"
  if (!mid) {
    return host.redirectToLogin();
  }

  return (
    <Suspense fallback={<CampaignPage product={product} loading />}>
      <CampaignPageLoggedOutInner mid={mid} product={product} />
    </Suspense>
  );
};
